import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field, PickSelect, StepHeader } from "@/components/apply/Field";
import { CATEGORIES, VOLUMES, YEARS, HEARD } from "@/data/options";

export const StepProfile = ({ form, update }) => {
  const p = form.profile;
  const set = (k) => (v) => update("profile", k, v);
  return (
    <div data-testid="step-profile">
      <StepHeader title="Your buyer profile" text="Help us understand your business and buying volume." />
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Business name" optional>
          <Input className="h-12 rounded-xl" value={p.business_name} onChange={(e) => set("business_name")(e.target.value)} data-testid="apply-business-name-input" />
        </Field>
        <Field label="Buyer category">
          <PickSelect value={p.category} onChange={set("category")} options={CATEGORIES} testId="apply-category-select" />
        </Field>
        <Field label="Estimated monthly volume">
          <PickSelect value={p.monthly_volume} onChange={set("monthly_volume")} options={VOLUMES} testId="apply-volume-select" />
        </Field>
        <Field label="Years in business">
          <PickSelect value={p.years_in_business} onChange={set("years_in_business")} options={YEARS} testId="apply-years-select" />
        </Field>
        <Field label="How did you hear about us?" optional>
          <PickSelect value={p.heard_about} onChange={set("heard_about")} options={HEARD} testId="apply-heard-select" />
        </Field>
        <Field label="Website or social links" optional>
          <Textarea rows={2} className="rounded-xl" value={p.links} onChange={(e) => set("links")(e.target.value)} placeholder="https://..." data-testid="apply-links-input" />
        </Field>
      </div>
    </div>
  );
};
